import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button
} from '@chakra-ui/react'
import { useRef } from 'react'

interface DeleteConfirmationDialogProps {
    isOpen: boolean
    onClose: () => void
    onDelete: () => void
    isLoading: boolean
    contactName: string
}

const DeleteConfirmationDialog = ({
    isOpen,
    onClose,
    onDelete,
    isLoading,
    contactName
}: DeleteConfirmationDialogProps) => {
    const cancelRef = useRef<HTMLButtonElement>(null)

    return (
        <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Delete Guardian Contact
                    </AlertDialogHeader>

                    <AlertDialogBody>
                        Are you sure you want to delete <b>{contactName}</b>? This action
                        cannot be undone.
                    </AlertDialogBody>

                    <AlertDialogFooter>
                        <Button variant="outline" ref={cancelRef} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="red"
                            onClick={onDelete}
                            ml={3}
                            isLoading={isLoading}
                        >
                            Delete
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export default DeleteConfirmationDialog
